<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card class="box-card">
					<!-- <h4>筛选查询</h4> -->
					<el-row>
						<el-col :span="20">
							<el-form :inline="true" :model="form" class="demo-form-inline" size="mini" ref="form">
								<el-form-item label="标题">
									<el-input placeholder="标题" v-model="form.title" size="mini"></el-input>
								</el-form-item>
								<el-form-item label="链接">
									<el-input placeholder="链接" v-model="form.website" size="mini"></el-input>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="getData">查询</el-button>
									<el-button type="danger" @click="clear()">清空</el-button>
								</el-form-item>
								<el-form-item>
									<button class="addAll" @click="update('add')">新增内容</button>
								</el-form-item>
							</el-form>
						</el-col>
						<el-col :span="2"></el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-table v-loading="loading" element-loading-text="拼命加载中"
								element-loading-spinner="el-icon-loading"
								element-loading-background="rgba(0, 0, 0, 0.8)" ref="multipleTable" :data="tableData"
								style="width: 100%" border size="mini"
								:header-cell-style="{background:'#E5E7EE',color:'#000000'}" row-key="id">
								<el-table-column type="selection" width="55" align="center">
								</el-table-column>
								<el-table-column align="center" :prop="dropCol[index].prop" :label="item.label"
									v-for="(item,index) in col" :key="`col_${index}`">
								</el-table-column>
								<!-- <el-table-column prop="title" label="标题" align="left">
								</el-table-column>
								<el-table-column prop="website" label="链接" align="center">
								</el-table-column> -->
								<el-table-column prop="type" label="类型" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.type == 1 ?'文字':'LOGO'}}</span>
									</template>
								</el-table-column>
								<el-table-column prop="logo" label="LOGO" align="center">
									<template slot-scope="scope">
										<div class="demo-image__preview" @click="preview(scope.row)">
											<img style="width: 80px; height: 80px"
												:src="settings.apiBaseImg+scope.row.logo">

										</div>
									</template>
								</el-table-column>

								<el-table-column fixed="right" label="操作">
									<template slot-scope="scope">
										<el-button type="success" icon="el-icon-edit" circle size="small"
											@click.native.prevent="update('update',scope.row)"></el-button>
										<el-button type="danger" icon="el-icon-delete" circle
											@click.native.prevent="deleteRow(scope.$index,scope.row)" size="small">
										</el-button>
										<!-- <el-button @click.native.prevent="update('update',scope.$index, scope.row,)" type="text" size="small">
											编辑
										</el-button>
										<span>|</span>
										<el-button @click.native.prevent="deleteRow(scope.$index, scope.row)" type="text" size="small">
											删除
										</el-button> -->
									</template>
								</el-table-column>
							</el-table>
							<div class="tableFooter">
								<button class="selectAll" @click="toggleSelection(tableData)">全选</button>
								<button class="del" @click="batDel">批量删除</button>
							</div>
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="currentPage" size="mini" :page-sizes="[10, 20, 30, 40]" :page-size="100"
								layout="total, prev, pager, next, jumper" :total="total">
							</el-pagination>
						</el-col>
					</el-row>

				</el-card>
			</el-col>
		</el-row>
		<fox-preview-image v-model="visiable" :src="srcList" z-index="9000"></fox-preview-image>
	</div>
</template>

<script>
	import qs from 'qs'
	import mock from '../../assets/mock/mock.js'
	export default {
		data() {
			return {
				form: {
					title: '',
					website: ''
				},
				col: [{
						label: '编号',
						prop: 'id'
					},
					{
						label: '标题',
						prop: 'title'
					},
					{
						label: '链接',
						prop: 'website'
					},
				],
				dropCol: [{
						label: '编号',
						prop: 'id'
					},
					{
						label: '标题',
						prop: 'title'
					},
					{
						label: '链接',
						prop: 'website'
					},
				],
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				loading: false,
				srcList: '',
				visiable: false
			}
		},
		created() {
			this.getData(this.currentPage, this.pageSize)
		},
		mounted() {
			this.rowDrop()
		},
		methods: {
			// 行拖拽
			rowDrop() {
				const tbody = document.querySelector('.el-table__body-wrapper tbody')
				const _this = this
				this.Sortable.create(tbody, {
					onEnd({
						newIndex,
						oldIndex
					}) {
						const currRow = _this.tableData.splice(oldIndex, 1)[0]
						_this.tableData.splice(newIndex, 0, currRow)
					}
				})
			},
			preview(rows) {
				this.visiable = true
				this.srcList = ''
				this.srcList = this.settings.apiBaseImg + rows.logo
			},
			getData(currentPage, pageSize) {
				this.loading = true
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/link/page',
					params: {

						title: this.form.title,
						type: '',
						website: this.form.website,
						pageNum: currentPage,
						pageSize: pageSize,
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.loading = false
						res.data.data.data.forEach(v => v.logo = this.getArray(v.logo))
						this.tableData = res.data.data.data
						this.total = res.data.data.total
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			getArray(pic) {
				var list = []
				list.push(pic)
				return list
			},
			//清空
			clear() {
				this.form.title = '',
					this.form.website = ''
				this.getData()
			},
			update(iden, rows) {
				this.$router.push({
					path: '/home/linkUpdate',
					query: {
						rows: rows,
						iden: iden
					}
				})
			},
			//全选
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			deleteRow(index, rows) {
				this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.loading = true
					var obj = this;
					obj.$http({
						method: 'get',
						url: 'api/v1/link/delete',
						params: {
							id: rows.id,
							uid: localStorage.getItem('uid')
						},
					}).then((res) => {
						if (res.data.status == 200) {
							this.loading = false
							obj.$message.success('删除成功')
							this.getData(this.currentPage, this.pageSize)
						} else {
							obj.$message.error(res.data.message)
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//批量删除
			batDel() {
				if (this.$refs.multipleTable.selection.length == 0) {
					this.$message.error('请选择要删除的表格信息！');
					return;
				}
				var list = []
				for (var i = 0; i < this.$refs.multipleTable.selection.length; i++) {
					list.push(this.$refs.multipleTable.selection[i].id)
				}
				this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.loading = true
					var obj = this;
					obj.$http({
						method: 'get',
						url: 'api/v1/link/clear',
						params: {
							ids: list.toString(),
							uid: localStorage.getItem('uid')
						},
					}).then((res) => {
						if (res.data.status == 200) {
							this.loading = false
							obj.$message.success('删除成功')
							this.getData(this.currentPage, this.pageSize)
						} else {
							obj.$message.error(res.data.message)
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//分页事件
			handleSizeChange(val) {
				this.pageSize = val; //将每页显示的条数 = 改变的值
				this.getData(this.currentPage, this.pageSize)
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData(this.currentPage, this.pageSize)
			},
		},
	}
</script>

<style scoped="scoped">
	span {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #7C96F8;
		line-height: 24px;
	}

	.chenggong {
		width: 49px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.7;
	}

	.fail {
		width: 33px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #76B67E;
		line-height: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/views/operate/link.vue